import { createElement, forwardRef } from 'react';
import { camelCase, upperFirst } from 'lodash';

export const Icons = {};

const context = require.context('.', false, /\.svg$/);
context.keys().forEach(filename => {
  const name = filename.replace(/(\.\/|\.svg$)/g, '');
  const Component = context(filename).default;
  const WrappedComponent = forwardRef((props, ref) => createElement(Component, {
    ...props,
    'ref': ref,
    'className': ['icon', props.className].filter(Boolean).join(' '),
    'data-icon': name,
  }));
  Icons[upperFirst(camelCase(name))] = WrappedComponent;
});
